import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getComparePlanListStyles = (isTableView, showBottomLeftRadius, showBottomRightRadius) => {
  var _tokens$spacing = tokens.spacing,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_0 = _tokens$spacing.SPACING_0;
  return StyleSheet.create({
    listContainer: Object.assign(Object.assign({
      borderBottomLeftRadius: SPACING_12,
      borderBottomRightRadius: SPACING_12
    }, isTableView && {
      borderBottomRightRadius: showBottomRightRadius ? SPACING_16 : SPACING_0,
      borderBottomLeftRadius: showBottomLeftRadius ? SPACING_16 : SPACING_0
    }), {
      overflow: 'hidden'
    })
  });
};